// Vuex UserProfiles module actions
import { API } from '@/config';

export default {
  async send(context, params) {
    try {
      await API.post('/configurationFormSendMail', params);
    } catch (error) {
      console.log(error);
    }
  },
};
